module.exports = __webpack_public_path__ + "media/soundNoti.ddaf938a.mp3";